module.exports = __webpack_public_path__ + "img/pro_five_8.f3ef4054.jpg";